import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
export type ConfirmAction = 'ok' | 'cancel';

export type ConfirmDialogIcon = 'purchase-cancel' | 'purchase-success';

export interface ConfirmDialogData {
  title?: string;
  message?: string;
  cancelLabel?: string;
  okLabel?: string;
  okOnly?: boolean;
  iconHeader?: ConfirmDialogIcon;
  showLoading?: boolean;
  loadingMessage?: string;
  panelClass?: string;
  maxWidth?: number;
}

export const defaultConfirmDialogData: ConfirmDialogData = {
  title: 'Confirm',
  cancelLabel: 'Cancel',
  okLabel: 'Yes',
  okOnly: false,
  showLoading: false,
  loadingMessage: 'Please wait while we process your request.'
};

@Component({
  selector: 'iq-confirm',
  templateUrl: './confirm.dialog.html',
  styleUrls: ['./confirm.dialog.scss']
})
export class ConfirmDialog implements OnInit {
  messageHtml: SafeHtml;
  public data: ConfirmDialogData;
  constructor(
    private _sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<ConfirmDialog, ConfirmAction>,
    @Optional() @Inject(MAT_DIALOG_DATA) private customData: ConfirmDialogData
  ) {
    this.data = customData
      ? { ...defaultConfirmDialogData, ...this.customData }
      : defaultConfirmDialogData;
  }

  ngOnInit() {
    if (this.data.message) {
      this.messageHtml = this._sanitizer.bypassSecurityTrustHtml(
        this.data.message
      );
    }
    if (this.data.showLoading) {
      this.dialogRef.disableClose = true;
    }

    // setTimeout( () => {
    //   this.dialogRef.disableClose = true;
    // } , 5000 );
  }
  showMessage() {
    this.data.showLoading = false;
    this.dialogRef.disableClose = false;
  }

  onCancel() {
    this.dialogRef.close('cancel');
  }
  onOk() {
    this.dialogRef.close('ok');
  }
}
